import { render } from "./CitiesList.vue?vue&type=template&id=1164dd54"
import script from "./CitiesList.vue?vue&type=script&lang=js"
export * from "./CitiesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__